import { useMemo, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const productCards = [
  // New Cattle Feed Products
  { category: 'Cattle Feed', img: '/images/products/cattle-feed/z-30-pro-detail-new.webp', alt: 'Z 30 PRO', title: 'Z 30 PRO', href: '/products/z-30-pro' },
  { category: 'Cattle Feed', img: '/images/products/cattle-feed/z-8000-pro-detail.webp', alt: 'Z 8000 PRO', title: 'Z 8000 PRO', href: '/products/z-8000' },
  { category: 'Cattle Feed', img: '/images/products/cattle-feed/z-10000-pro-detail.webp', alt: 'Z 10000 PRO', title: 'Z 10000 PRO', href: '/products/z-10000' },
  { category: 'Pig Feed', img: '/images/products/pig-feed/zfast-starter.webp', alt: 'ZFAST Pig Starter feed packaging', title: 'Pig Starter', href: '/products/pig-starter' },
  { category: 'Pig Feed', img: '/images/products/pig-feed/zfast-grower.webp', alt: 'ZFAST Pig Grower feed packaging', title: 'Pig Grower', href: '/products/pig-grower' },
  { category: 'Pig Feed', img: '/images/products/pig-feed/zfast-finisher.webp', alt: 'ZFAST Pig Finisher feed packaging', title: 'Pig Finisher', href: '/products/pig-finisher' },
  { category: 'Pig Feed', img: '/images/products/pig-feed/sow-gestation.webp', alt: 'ZFAST Sow Gestation feed packaging', title: 'Sow Gestation', href: '/products/sow-gestation' },
  { category: 'Pig Feed', img: '/images/products/pig-feed/sow-lactation.webp', alt: 'ZFAST Sow Lactation feed packaging', title: 'Sow Lactation', href: '/products/sow-lactation' },

  // Edible Oils (Coming Soon)
  { category: 'Edible Oils', img: '/images/products/edible-oils/oil-mustard.webp', alt: 'Mustard Oil', title: 'Mustard Oil (Coming Soon)' },
  { category: 'Edible Oils', img: '/images/products/edible-oils/oil-soybean.webp', alt: 'Soybean Refined Oil', title: 'Soybean Refined Oil (Coming Soon)' },
  { category: 'Edible Oils', img: '/images/products/edible-oils/oil-sunflower.webp', alt: 'Sunflower Oil', title: 'Sunflower Oil (Coming Soon)' }
];

const tabs = ['All', 'Cattle Feed', 'Pig Feed', 'Edible Oils'];

export function ZfastSectionsAsIs() {
const location = useLocation();
  const [activeFilter, setActiveFilter] = useState('All');
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (location.hash) {
      const hash = decodeURIComponent(location.hash.replace('#', ''));
      if (tabs.includes(hash)) {
        setActiveFilter(hash);
        setExpanded(hash !== 'All');
      }
    }
  }, [location.hash]);

  const visibleCards = useMemo(() => {
    return productCards.map((card, index) => {
      const filterMatch = activeFilter === 'All' || card.category === activeFilter;
      const shouldHide = !filterMatch || (activeFilter === 'All' && !expanded && index >= 8);
      return { ...card, hidden: shouldHide };
    });
  }, [activeFilter, expanded]);

  const applyFilter = (filter: string) => {
    setActiveFilter(filter);
    setExpanded(filter !== 'All');
  };

  const toggleMore = () => {
    setExpanded((value) => !value);
  };

  return (
    <div className="zfast-exact" id="zfast-sections-as-is">
      <style>{`
.zfast-exact{
  --blue:#1A5C2E;
  --blue-dark:#102118;
  --green:#2D8A47;
  --orange:#C8900A;
  --yellow:#E8B438;
  --cream:#FAFAF7;
  --ink:#102118;
  --muted:#5f6b61;
  --line:#D8EFE0;
  --white:#fff;
  --shadow:0 24px 70px rgba(16,33,24,.14);
  margin:0;
  font-family:inherit;
  color:var(--ink);
  background:#fff;
  overflow-x:hidden;
}
.zfast-exact *{box-sizing:border-box}
.zfast-exact img{max-width:100%;display:block}
.zfast-exact a{color:inherit;text-decoration:none}
.zfast-exact .container{width:min(1180px,calc(100% - 36px));margin:auto}
.zfast-exact .section{padding:76px 0}
.zfast-exact .eyebrow{font-size:13px;letter-spacing:.22em;text-transform:uppercase;color:var(--orange);font-weight:900;margin:0 0 14px}
.zfast-exact .title{font-size:clamp(34px,4vw,58px);line-height:1.02;margin:0 0 16px;color:var(--blue-dark);letter-spacing:-.045em}
.zfast-exact .lead{font-size:clamp(17px,1.4vw,21px);line-height:1.65;color:var(--muted);margin:0}
.zfast-exact .btn{display:inline-flex;align-items:center;justify-content:center;gap:10px;padding:14px 24px;border-radius:14px;background:var(--orange);color:white;font-weight:900;box-shadow:0 14px 28px rgba(200,144,10,.22);transition:.25s;border:0;cursor:pointer;font-family:inherit;font-size:16px}
.zfast-exact .btn:hover{transform:translateY(-2px);background:#A97608}
.zfast-exact .btn.alt{background:var(--blue)}
.zfast-exact .feeds{background:linear-gradient(135deg,var(--cream),#EFF8F1);padding:86px 0}
.zfast-exact .feeds-grid{display:grid;grid-template-columns:1.1fr .9fr;gap:50px;align-items:center}
.zfast-exact .feeds-copy h3{font-size:clamp(26px,2.4vw,36px);color:var(--ink);line-height:1.2;margin:8px 0 18px}
.zfast-exact .feeds-copy p{font-size:19px;line-height:1.72;color:#4a5a66}
.zfast-exact .bag-photo{position:relative}
.zfast-exact .bag-photo img{height:430px;width:100%;object-fit:contain;filter:drop-shadow(0 22px 30px rgba(0,0,0,.18))}
.zfast-exact .afla{background:#fff}
.zfast-exact .afla-card{display:grid;grid-template-columns:.92fr 1.08fr;gap:44px;align-items:center;background:#f8fbff;border:1px solid var(--line);border-radius:34px;padding:34px;box-shadow:var(--shadow)}
.zfast-exact .afla-media{border-radius:26px;background:#fff;overflow:hidden;padding:20px}
.zfast-exact .afla-media img{height:360px;width:100%;object-fit:contain}
.zfast-exact .afla-copy p{font-size:19px;line-height:1.7;color:#4d5d6c}
.zfast-exact .products{background:linear-gradient(180deg,#fff,#F4FBF6);padding:86px 0}
.zfast-exact .tabs{display:flex;gap:10px;flex-wrap:nowrap;margin:28px 0 34px;overflow-x:auto;padding-bottom:8px;scrollbar-width:none;}
.zfast-exact .tabs::-webkit-scrollbar{display:none;}
.zfast-exact .tab{border:1px solid var(--line);background:#fff;color:var(--blue-dark);font-weight:900;padding:12px 20px;border-radius:14px;cursor:pointer;font-family:inherit;font-size:16px;white-space:nowrap;flex-shrink:0;}
.zfast-exact .tab.active{background:var(--blue);color:#fff;border-color:var(--blue)}
.zfast-exact .product-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px}
.zfast-exact .product{background:#fff;border:1px solid var(--line);border-radius:24px;box-shadow:0 10px 34px rgba(20,93,160,.07);padding:18px;min-height:320px;display:flex;flex-direction:column;align-items:center;justify-content:space-between;transition:.25s}
.zfast-exact .product:hover{transform:translateY(-5px);box-shadow:var(--shadow)}
.zfast-exact .product img{height:215px;width:100%;object-fit:contain}
.zfast-exact .product h3{font-size:20px;text-align:center;color:var(--blue-dark);margin:16px 0 0}
.zfast-exact .product small{color:var(--orange);font-weight:900}
.zfast-exact .product.hidden{display:none}
.zfast-exact .load-wrap{text-align:center;margin-top:34px}
.zfast-exact .calculators{background:#102118;color:#fff;padding:86px 0;position:relative;overflow:hidden}
.zfast-exact .calc-grid{position:relative;display:grid;grid-template-columns:1fr;gap:42px;align-items:center}
.zfast-exact .calculators .title{color:#fff}
.zfast-exact .calculators .lead{color:rgba(255,255,255,.85)}
.zfast-exact .calc-links{display:flex;gap:14px;flex-wrap:wrap;margin-top:26px}
.zfast-exact .calc-links a{padding:14px 20px;border-radius:16px;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.2);font-weight:900}
@media(max-width:980px){.zfast-exact .feeds-grid,.zfast-exact .afla-card,.zfast-exact .calc-grid{grid-template-columns:1fr}.zfast-exact .product-grid{grid-template-columns:repeat(2,1fr)}.zfast-exact .bag-photo img,.zfast-exact .afla-media img{height:280px}.zfast-exact .section,.zfast-exact .feeds,.zfast-exact .products,.zfast-exact .calculators{padding:60px 0}}
    @media(max-width:560px){.zfast-exact .container{width:min(100% - 24px,1180px)}.zfast-exact .btn{width:100%}.zfast-exact .product-grid{grid-template-columns:repeat(2,1fr); gap:12px;}.zfast-exact .title{font-size:34px}.zfast-exact .product img{height:140px;}.zfast-exact .product h3{font-size:16px; margin-top:8px;}.zfast-exact .product{min-height:220px; padding:12px;}}
    .zfast-exact .feeds{background:linear-gradient(135deg,#FAFAF7,#EFF8F1)}
    .zfast-exact .products{background:linear-gradient(180deg,#fff,#F4FBF6)}
    .zfast-exact .calculators{background:linear-gradient(135deg,#102118,#1A5C2E)}
    .zfast-exact .btn{background:var(--orange)}
    .zfast-exact .btn:hover{background:#A97608}
    .zfast-exact .btn.alt{background:var(--blue)}
    .zfast-exact .tab.active{background:var(--blue);border-color:var(--blue)}
    .zfast-exact .product small,
    .zfast-exact .eyebrow{color:var(--orange)}
    .zfast-exact .bag-photo::after,
    .zfast-exact .calculators::before{display:none !important;content:none !important}
    .zfast-exact .btn,
    .zfast-exact .tab{border-radius:14px !important}
    .zfast-exact .product-link {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      text-decoration: none;
      color: inherit;
    }
    .zfast-exact .view-details {
      margin-top: 8px;
      font-size: 14px;
      color: var(--blue);
      font-weight: 700;
    }
          `}</style>



          <section className="products" id="products">
            <div className="container">
              <p className="eyebrow">Product Finder</p>
              <h2 className="title">Choose the right ZFAST product as per the need of your dairy animal.</h2>
              <p className="lead">The product grid is split by category and includes the visible product assets from the source page.</p>
              <div className="tabs" role="tablist">
                <button className={`tab ${activeFilter === 'All' ? 'active' : ''}`} data-filter="All" type="button" onClick={() => applyFilter('All')}>All Products</button>
                <button className={`tab ${activeFilter === 'Cattle Feed' ? 'active' : ''}`} data-filter="Cattle Feed" type="button" onClick={() => applyFilter('Cattle Feed')}>Cattle Feed</button>
                <button className={`tab ${activeFilter === 'Pig Feed' ? 'active' : ''}`} data-filter="Pig Feed" type="button" onClick={() => applyFilter('Pig Feed')}>Pig Feed</button>
                <button className={`tab ${activeFilter === 'Edible Oils' ? 'active' : ''}`} data-filter="Edible Oils" type="button" onClick={() => applyFilter('Edible Oils')}>Edible Oils</button>
              </div>
              <div className="product-grid" id="productGrid">
                {visibleCards.map((product, index) => (
                  <article className={`product ${product.hidden ? 'hidden' : ''}`} data-category={product.category} key={`${product.title}-${index}`}>
                    {product.href ? (
                      <Link to={product.href} className="product-link">
                        <img src={product.img || '/zfast-logo.webp'} alt={product.alt} decoding="async" />
                        <small style={{ marginTop: 'auto' }}>{product.category}</small>
                        <h3>{product.title}</h3>
                        <span className="view-details">View Details &rarr;</span>
                      </Link>
                    ) : (
                      <>
                        <img src={product.img || '/zfast-logo.webp'} alt={product.alt} decoding="async" />
                        <small style={{ marginTop: 'auto' }}>{product.category}</small>
                        <h3>{product.title}</h3>
                        <span className="view-details" style={{ color: 'var(--muted)' }}>Coming Soon</span>
                      </>
                    )}
                  </article>
                ))}
          </div>
          <div className="load-wrap">
            {activeFilter === 'All' ? (
              <button className="btn alt" id="loadMore" type="button" onClick={toggleMore}>{expanded ? 'Show Less' : 'Load More'}</button>
            ) : null}
          </div>
        </div>
      </section>


    </div>
  );
}
